var blockBundles;

try {
  blockBundles = {
    tqht_mansite: {
      content: {
        intro: {
          html: require("../../tqht_mansite/intro/intro.html.twig"),
          scss: require("../../tqht_mansite/intro/intro.scss"),
          js: require("../../tqht_mansite/intro/intro.js"),
          dir: "tqht_mansite/intro/intro",
        },
        header: {
          html: require("../../tqht_mansite/header/header.html.twig"),
          scss: require("../../tqht_mansite/header/header.scss"),
          js: require("../../tqht_mansite/header/header.js"),
          dir: "tqht_mansite/header/header",
        },
        news_event: {
          html: require("../../tqht_mansite/news_event/news_event.html.twig"),
          scss: require("../../tqht_mansite/news_event/news_event.scss"),
          js: require("../../tqht_mansite/news_event/news_event.js"),
          dir: "tqht_mansite/news_event/news_event",
        },
        char: {
          html: require("../../tqht_mansite/char/char.html.twig"),
          scss: require("../../tqht_mansite/char/char.scss"),
          js: require("../../tqht_mansite/char/char.js"),
          dir: "tqht_mansite/char/char",
        },
       
        floattop: {
          html: require("../../tqht_mansite/floattop/floattop.html.twig"),
          scss: require("../../tqht_mansite/floattop/floattop.scss"),
          js: require("../../tqht_mansite/floattop/floattop.js"),
          dir: "tqht_mansite/floattop/floattop",
        },
        floatleft: {
          html: require("../../tqht_mansite/floatleft/floatleft.html.twig"),
          scss: require("../../tqht_mansite/floatleft/floatleft.scss"),
          js: require("../../tqht_mansite/floatleft/floatleft.js"),
          dir: "tqht_mansite/floatleft/floatleft",
        },
        float_right: {
          html: require("../../tqht_mansite/float_right/float_right.html.twig"),
          scss: require("../../tqht_mansite/float_right/float_right.scss"),
          js: require("../../tqht_mansite/float_right/float_right.js"),
          dir: "tqht_mansite/float_right/float_right",
        },
      
     
        newworld: {
          html: require("../../tqht_mansite/newworld/newworld.html.twig"),
          scss: require("../../tqht_mansite/newworld/newworld.scss"),
          js: require("../../tqht_mansite/newworld/newworld.js"),
          dir: "tqht_mansite/newworld/newworld",
        },
      
        subpage: {
          html: require("../../tqht_mansite/subpage/subpage.html.twig"),
          scss: require("../../tqht_mansite/subpage/subpage.scss"),
          js: require("../../tqht_mansite/subpage/subpage.js"),
          dir: "tqht_mansite/subpage/subpage",
        },
        sub_floattop: {
          html: require("../../tqht_mansite/sub_floattop/sub_floattop.html.twig"),
          scss: require("../../tqht_mansite/sub_floattop/sub_floattop.scss"),
          js: require("../../tqht_mansite/sub_floattop/sub_floattop.js"),
          dir: "tqht_mansite/sub_floattop/sub_floattop",
        },
      },
    },
    common: {
      required: {
        required_loading: {
          html: require("../../common/required_loading/required_loading.html.twig"),
          scss: require("../../common/required_loading/required_loading.scss"),
          js: require("../../common/required_loading/required_loading.js"),
          dir: "common/required_loading/required_loading",
        },
      },
    },
  };
} catch (error) {
  console.log(error);
}

export default blockBundles;
